import Bookmark from '@/classes/bookmark';

const state = () => ({
  bookmarks: {},
});

const getters = {
  activeBookmarks: state => Object.keys(state.bookmarks).map(id => state.bookmarks[id]).filter(b => !b.deleted),
  bookmarkList: state => Object.keys(state.bookmarks).map(id => state.bookmarks[id]),
  get: state => state.bookmarks,
};

const mutations = {
  setBookmarks(state, bookmarks) {
    for(let bookmark of bookmarks) {
      let id = `${bookmark.bookmarkableType}-${bookmark.bookmarkableId}`;
      state.bookmarks[id] = bookmark;
    }
  },
  reset(s) {
    Object.assign(s, state());
  },
  updateBookmark(state, params) {
    if (!params) return;
    if (!params.id) return;
    if (!state.bookmarks[params.id]) return;
    state.bookmarks[params.id].deleted = params.deleted;
  },
};

const actions = {
  fetchBookmarks({ dispatch, commit, getters, rootGetters }) {
    return rootGetters['session/ajax'].get('/bookmarks').then(response => {
      const classyBookmarks = response.data.bookmarks?.map(b => new Bookmark(b));
      commit('setBookmarks', classyBookmarks);
      return classyBookmarks;
    });
  },
  createBookmark({ dispatch, commit, getters, rootGetters }, params) {
    return rootGetters['session/ajax'].post('/bookmarks', params).then(response => {
      const bookmark = response.data?.bookmark;
      if (bookmark) {
        commit('setBookmarks', [new Bookmark(bookmark)]);
      }
      return response;
    });
  },
  updateBookmark({ dispatch, commit, getters, rootGetters }, params) {
    return rootGetters['session/ajax'].put(`/bookmarks/${params.id}`, params).then(response => {
      const bookmark = response.data?.bookmark;
      if (bookmark) {
        commit('setBookmarks', [new Bookmark(bookmark)]);
      }
      return response;
    });
  },
  toggleBookmark({ dispatch }, bookmark) {
    return dispatch('updateBookmark', {
      id: bookmark.id,
      deleted: !bookmark.deleted,
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
